import {
  ToggleGroup,
  ToggleGroupItem,
} from "../../../components/ui/toggle-group";

export function ItemsPerPageToggleGroup({ defaultValue, onChange, className }) {
  return (
    <ToggleGroup
      type="single"
      aria-label="Items per page"
      defaultValue={defaultValue + ""}
      onValueChange={onChange}
      className={`grid grid-cols-5 gap-0 bg-white overflow-hidden ${className || ""}`}
    >
      <ToggleGroupItem
        value="1"
        aria-label="1 item per page"
        size="lg"
        className="rounded-tl-xl rounded-bl-xl"
      >
        1
      </ToggleGroupItem>
      <ToggleGroupItem value="2" size="lg" aria-label="2 items per page">
        2
      </ToggleGroupItem>
      <ToggleGroupItem value="3" size="lg" aria-label="3 items per page">
        3
      </ToggleGroupItem>
      <ToggleGroupItem value="4" size="lg" aria-label="4 items per page">
        4
      </ToggleGroupItem>
      <ToggleGroupItem
        value="5"
        size="lg"
        aria-label="5 items per page"
        className="rounded-tr-xl rounded-br-xl"
      >
        5
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
